import { SiteLanding } from '../components/site/SiteLanding';
import { usePageSeo } from '../hooks/usePageSeo';
import { organizationJsonLd, PAGE_SEO, websiteJsonLd } from '../lib/seo';

export function HomePage() {
  usePageSeo({
    ...PAGE_SEO.home,
    jsonLd: [organizationJsonLd(), websiteJsonLd()],
  });

  return <SiteLanding />;
}
